<template>
  <div v-if="steps && steps.length" class="breakdown">
    <button class="link-btn" @click="open = !open">
      {{ open ? 'Скрыть шаги' : `Показать как считала ИИ (${steps.length})` }}
    </button>
    <div v-if="open" class="steps">
      <ToolCallCard v-for="s in steps" :key="s.id" :step="s"/>
    </div>
  </div>
</template>

<script>
import ToolCallCard from './ToolCallCard.vue';

export default {
  name: 'ToolStepsBreakdown',
  components: { ToolCallCard },
  props: {
    steps: { type: Array, default: () => [] },
    initialOpen: { type: Boolean, default: false },
  },
  data() {
    return { open: this.initialOpen };
  },
};
</script>

<style scoped lang="scss">
.breakdown {
  margin: 10px 0 4px;
}
.link-btn {
  background: transparent;
  border: none;
  padding: 0;
  color: var(--ai-text-muted);
  font-size: 13px;
  cursor: pointer;
  &:hover { color: var(--ai-text); }
}
.steps { margin-top: 6px; }
</style>
